import request from '@/utils/request'

const couponURL = {
  List: '/coupon/list',
  Detail: '/coupon/view',
  Create: '/coupon/create',
  Update: '/coupon/update',
  Delete: '/coupon/delete',
  Recovery: '/coupon/recovery'
}

// 新建优惠券
export function createCoupon (data) {
  return request({
    url: couponURL.Create,
    method: 'post',
    data
  })
}

// 优惠券列表
export function getListCoupon (data) {
  return request({
    url: couponURL.List,
    method: 'post',
    data
  })
}

// 优惠券详情
export function getDetailCoupon (data) {
  return request({
    url: couponURL.Detail,
    method: 'post',
    data
  })
}

// 优惠券更新
export function updateCoupon (data) {
  return request({
    url: couponURL.Update,
    method: 'post',
    data
  })
}

// 优惠券删除
export function deleteCoupon (data) {
  return request({
    url: couponURL.Delete,
    method: 'post',
    data
  })
}

// 优惠卷恢复
export function recoveryCoupon (data) {
  return request({
    url: couponURL.Recovery,
    method: 'post',
    data
  })
}

export default {
  createCoupon,
  deleteCoupon,
  updateCoupon,
  getListCoupon,
  getDetailCoupon,
  recoveryCoupon
}
